// Éles környezet
// clientApiUrl:
//  - Az az url amit a böngésző használ az API hívásokhoz
// serverApiUrl:
//  - Az az url amit SSR-nél a Node használ az API hívásokhoz
// translation:
//  - locales: az oldalon használt nyelvek listája
//  - prefix: a route fordítókulcsok prefixe
//  - localesFolder: a mappa elérési útja, ahol a fordításhoz használt {lang}.JSON fájlok találhatók.

import { IEnvironment } from './environment.definitions';

export const environment: IEnvironment = {
  production: true,
  type: 'prod',
  apiUrl: {
    clientApiUrl: 'https://visithungary.com/publicapi',
    serverApiUrl: 'https://visithungary.com/publicapi',
  },
  csodasApiUrl: {
    clientApiUrl: 'https://csodasmagyarorszag.hu/publicapi',
    serverApiUrl: 'https://csodasmagyarorszag.hu/publicapi',
  },
  domainReplacements: [
    {
      includes: '/summer-accommodation/',
      replaces: [ 'visithungary.com', 'csodasmagyarorszag.hu' ]
    },
  ],
  domain: 'https://visithungary.com/',
  csodasDomain: 'https://csodasmagyarorszag.hu/',
  weatherApiUrl: 'https://185.161.73.82',
  translation: {
    locales: ['en', 'hu', 'es', 'cs', 'de', 'fr', 'it', 'pl', 'ro', 'sk', 'he', 'hr', 'ko', 'ru', 'sl', 'cn', 'sr', 'tr'],
    prefix: 'ROUTES.',
    localesFolder: {
      client: '/assets/locales',
      server: '/../browser/assets/locales',
    },
  },
  googleApiKey: 'AIzaSyDR0GUH4WTMjga_6eAIs0_Qw-leSjffuYc',
  gtmKey: 'GTM-MQRKTJB',
  recaptchaKey: '6Lf2WtQmAAAAAAZIDbxEfjBQYuC0oZY0XVXysXLW',
  watsonxOrchestrate: {
    tokenEndpoint: '/publicapi/hu/jwt/create-rs-256-token',
    enabled: true,
    hostURL: 'https://eu-de.watson-orchestrate.cloud.ibm.com',
    orchestrationID: '9ebbb3d5703b409cbbffbcf6c1a2bc10_58c56c1a-ff8a-4f11-825d-4242f1b296d7',
    rootElementID: 'root',
    deploymentPlatform: 'ibmcloud',
    crn: 'crn:v1:bluemix:public:watsonx-orchestrate:eu-de:a/9ebbb3d5703b409cbbffbcf6c1a2bc10:58c56c1a-ff8a-4f11-825d-4242f1b296d7::',
    agentId: '15450d1a-d426-477c-8c5d-1a1fc0ead51b',
    agentEnvironmentId: '593cc139-4895-4556-91e1-9642ed2a7782',
  },
};
